<!-- <img *ngIf="displayHeader" src="assets/elis-connect-logo.png" style="width: 100px; display: block; margin: 20px auto 0 auto;" /> -->

<div *ngIf="shop$ | async as shop; else loading" class="pannel">

  <div style="background-color: white;">
    <div style="min-height: 250px;">
      <ng-container *ngIf="pictures$ | async as pictures">
        <ng-container *ngIf="pictures.length > 0">
          <div style="width: 100%; height: 250px; background-size: cover; background-position: center;" [ngStyle]="{ 'background-image': 'url(' + pictures[0] + ')' }"></div>
        </ng-container>
        <ng-container *ngIf="pictures.length === 0">
          <img style="width: 100%; min-height: 250px; display: block;" src="https://maps.googleapis.com/maps/api/streetview?size=400x250&location={{shop.location.latitude}},{{shop.location.longitude}}&fov=80&heading=70&pitch=0&key=AIzaSyDBnKojKHhOntc0nc5vAZed1ySiEXh2kTs" />
        </ng-container>
      </ng-container>
    </div>

    <mat-divider></mat-divider>
    <div style="padding: 16px 24px 16px;">
      <h1 style="font-size: 1.375rem; padding: 0; margin: 0;">{{shop.name}}</h1>
      <h2 style="font-size: 1rem; padding: 0; margin: 0; font-weight: 200; color: #757575;">{{shop.businessSector}}</h2>
    </div>
    <mat-divider></mat-divider>
  </div>

  <br />

  <div style="background-color: white;">
    <mat-divider></mat-divider>

    <mat-list dense>
      <mat-list-item>
        <mat-icon matListIcon style="color: #2E3D99">room</mat-icon>
        <h3 matLine><a href="http://maps.google.com/maps?daddr={{shop.location.latitude}},{{shop.location.longitude}}" target="_blank">{{shop.address}}, 92300 Levallois-Perret</a></h3>
      </mat-list-item>
      <mat-list-item *ngIf="shop.website">
        <mat-icon matListIcon style="color: #2E3D99">language</mat-icon>
        <h3 matLine><a href="{{shop.website}}" target="_blank">{{ (shop.website.length > 60) ? (shop.website | slice:0:60)+'...' : shop.website}}</a></h3>
      </mat-list-item>
      <mat-list-item *ngIf="shop.phone">
        <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
        <h3 matLine><a href="tel:{{shop.phone}}">{{shop.phone}}</a></h3>
      </mat-list-item>
      <mat-list-item *ngIf="shop.email">
        <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
        <h3 matLine><a href="mailto:{{shop.email}}">{{shop.email}}</a></h3>
      </mat-list-item>
      <mat-list-item *ngIf="shop.open === true">
        <mat-icon matListIcon svgIcon="door" style="color: #2E3D99"></mat-icon>
        <h3 matLine>Peut accueillir du public</h3>
      </mat-list-item>
      <mat-list-item *ngIf="shop.delivery === true">
        <mat-icon matListIcon svgIcon="truck-fast-outline" style="color: #2E3D99"></mat-icon>
        <h3 matLine>Réalise des livraisons</h3>
      </mat-list-item>
      <!-- <mat-list-item *ngIf="shop.delivery === false">
        <mat-icon matListIcon svgIcon="truck" style="color: #2E3D99"></mat-icon>
        <h3 matLine>Ne réalise pas de livraisons</h3>
      </mat-list-item> -->
      <mat-list-item *ngIf="shop.pickUp === true">
        <mat-icon matListIcon svgIcon="walk" style="color: #2E3D99"></mat-icon>
        <h3 matLine>Vente à emporter possible</h3>
      </mat-list-item>
      <!-- <mat-list-item *ngIf="shop.pickUp === false">
        <mat-icon matListIcon svgIcon="human-male" style="color: #2E3D99"></mat-icon>
        <h3 matLine>Ne fait pas de vente à emporter</h3>
      </mat-list-item> -->
    </mat-list>

    <mat-divider></mat-divider>
  </div>

  <br />

  <div *ngIf="shop.comment" style="background-color: white;">
    <mat-divider></mat-divider>

    <div style=" padding: 16px 24px 16px;">
      <h3>Informations complémentaires</h3>
      <p [innerHTML]="shop.comment | nl2br"></p>
    </div>

    <mat-divider></mat-divider>
  </div>

  <br />

  <div *ngIf="(pictures$ | async)?.length > 0" style="background-color: white;">
    <mat-divider></mat-divider>

    <div style="padding: 16px 24px 0 24px;">
      <h3>Photos</h3>
    </div>
    <div style="display: flex; flex-wrap: wrap; justify-content: space-evenly; padding-bottom: 16px;">
      <div *ngFor="let picture of (pictures$ | async); let i=index" style="padding: 5px;">
        <div class="picture" [ngStyle]="{ 'background-image': 'url(' + picture + ')' }" (click)="displayImage(i)"></div>
      </div>
    </div>

    <mat-divider></mat-divider>
  </div>

</div>

<ng-template #loading>
  <div style=" margin: auto; width: 100px; height: 100px; text-align: center; margin-top: 100px;">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>